import "./index.css"
import { StrictMode } from 'react'
import { routerTree } from './routes/_root';
import { createRoot } from 'react-dom/client'
import TanstackProvider from './contexts/TanstackProvider';
import { RouterProvider, createHashHistory, createRouter } from "@tanstack/react-router";
import { Toaster } from 'sonner'
import { ThemeProvider } from './components/app/ThemeProvider';

const hashHistory = createHashHistory()
const router = createRouter({ routeTree: routerTree, history: hashHistory });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <TanstackProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </TanstackProvider>
    </ThemeProvider>
  </StrictMode>,
)
